<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div>
        <TitleTips
          :routerList="routerList"
          routeType="/gywm/organizationalStructure"
          title="组织架构"
        />
      </div>
      <div
        calss="organitionImg"
        style="display: flex; justify-content: center; margin-bottom: 0.1rem"
      >
        <img
          style="width: 100%"
          :src="getFileUrl(pageObj.url)"
          alt=""
          v-if="pageObj.url"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
import getUrl from '../utils/urlHelp';
export default {
  components: {
    TitleTips
  },
  name: 'organizationalStructure',
  data() {
    return {
      pageLoading: false,
      imgUrlBanner: '',
      pageObj: {},
      routerList: []
    };
  },
  created() {
    this.pageLoading = true;
    http
      .post('/reception/about/getAllUs', { groupType: '106', title: '' })
      .then(res => {
        this.pageObj = Object.assign({}, res.rows[0]);
      })
      .finally(() => {
        this.pageLoading = false;
      });
  },
  mounted() {
    this.routerList = this.$route.matched;
  },
  methods: {
    getFileUrl(str) {
      const res = getUrl(str);
      return res;
    }
  },
  watch: {
    // $route: {
    //   handler: function(val, oldVal){
    //     if(val!=oldVal){
    //     }
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .organitionImg {
      width: 100%;
      img {
        // width:;
      }
    }
  }
}
</style>
